import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getEmployee = createAsyncThunk(
  "admin/employee",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/employee", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getEmployeeById = createAsyncThunk(
  "admin/employee/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/employee/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortEmployee = createAsyncThunk(
  "admin/employee/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/employee/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postEmployee = createAsyncThunk(
  "admin/employee/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/employee", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  "admin/employee/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/employee/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "admin/employee/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/employee/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const employeeSlice = createSlice({
  name: "Employee Store",
  initialState: initialState,
  reducers: {
    addEmployee(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortEmployee(state, action) {
      state.data.docs = action.payload;
    },
    deleteEmployee(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editEmployee(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getEmployee.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getEmployee.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getEmployee.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getEmployeeById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getEmployeeById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getEmployeeById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortEmployee.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortEmployee.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortEmployee.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postEmployee.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postEmployee.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postEmployee.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteEmployee.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteEmployee.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteEmployee.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateEmployee.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateEmployee.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateEmployee.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const employeeActions = employeeSlice.actions;

export default employeeSlice.reducer;
